import { useCallback, useEffect, useState } from 'react';
import { InputProps } from '../../../aura';
import { FormContextData, Validator, useFormContext } from '../../../state';
import { useBlur } from './use-blur';
import { getExtraInputProps } from './get-extra-input-props';

export function useValidator(
  validate: (data: FormContextData) => string | null,
) {
  const [wasValidated, setWasValidated] = useState(false);
  const { registerValidator } = useFormContext();

  const validator: Validator = useCallback(
    async (data: FormContextData) => {
      setWasValidated(true);
      return { error: validate(data) };
    },
    [validate],
  );
  useEffect(() => {
    return registerValidator(validator);
  }, [registerValidator, validator]);

  return wasValidated;
}

export function useValidation(
  t: (s: string) => string,
  hasValue: (data: FormContextData) => string | null,
  validate?: (data: FormContextData) => string | null,
): Partial<InputProps> {
  if (!validate) {
    validate = hasValue;
  }

  const { data } = useFormContext();
  const wasValidated = useValidator(validate);
  const { wasBlurred, onBlur } = useBlur();

  return {
    ...getExtraInputProps(
      t,
      !hasValue(data),
      !validate(data),
      wasValidated || wasBlurred,
    ),
    onBlur,
  };
}
